import { Tooltip, IconButton } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { missionPlannerStore, type MissionTool } from '../../stores/MissionStore';

interface ToolButtonProps {
  label: string;
  icon: React.ReactNode;
  tool: MissionTool;
  disabled?: boolean;
}

const ToolButton: React.FC<ToolButtonProps> = observer(({ label, icon, tool, disabled = false }) => {
  const isActive = missionPlannerStore.activeTool === tool;
  return (
    <Tooltip title={disabled ? `${label} (Requires takeoff point)` : label} placement='bottom'>
      <IconButton
        variant='plain'
        color='neutral'
        disabled={disabled}
        onClick={() => !disabled && missionPlannerStore.setActiveTool(tool)}
        sx={{
          '&:hover': {
            stroke: disabled ? 'neutral.600' : isActive ? 'black' : 'white',
            backgroundColor: disabled ? 'transparent' : isActive ? '#F5D907' : 'transparent'
          },
          backgroundColor: disabled ? 'transparent' : isActive ? '#F5D907' : 'transparent',
          '& svg, & svg *': {
            fill: disabled ? 'neutral.600 !important' : isActive ? 'black' : 'white !important',
            stroke: disabled ? 'neutral.600 !important' : isActive ? 'black' : 'white !important'
          },
          width: '50px',
          height: '50px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1
        }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
});

export default ToolButton;
